import { render, staticRenderFns } from "./exchangelist.vue?vue&type=template&id=23e08f92&"
import script from "./exchangelist.vue?vue&type=script&lang=js&"
export * from "./exchangelist.vue?vue&type=script&lang=js&"
import style0 from "./exchangelist.vue?vue&type=style&index=0&id=23e08f92&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports